import { Button, Pagination, Space, Switch, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import React, { useState } from "react";
import { PaginationProps } from "antd/lib/pagination";
import { CONSTANT } from "../../../../config/Constant";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
// import { checkPrivileges } from '../../../../config/Global';
import { fetchEditUser } from "../../../../store/UserSlice";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import DeleteUser from "./DeleteUser";
import { camelCaseString } from "../../../../config/Global";
interface DataType {
  index: number;
  username: string;
  full_name: string;
  email: string;
  active: boolean;
  language: string;
  created_at: string;
  roles: any[];
  _id: string;
  created_date: string | any;
}

const ListTable: React.FC<any> = (props) => {
  const {
    listData,
    setListData,
    totalData,
    tableloading,
    setTableLoading,
    paginationData,
    setPaginationData,
    getList,
    savePayload,
    handleEditModal,
  } = props;

  const dispatch: AppDispatch = useDispatch();

  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [openDeleteData, setOpenDeleteData] = useState<any>();
  // const userDetails = localStorage.getItem('userDetails');
  // const userRoles = userDetails && JSON.parse(userDetails)?.roles;

  const handleBlockUser = (record: any, val: boolean) => {
    const payload = {
      username: record?.username,
      active: val,
    };
    dispatch(fetchEditUser(payload))
      .then((res: any) => {
        // handleEditModal();
        getList();
      })
      .catch((error: any) => {
        console.log("error", error);
      });
  };
  // const handleDelete = (record: any) => {
  //   const payload = {
  //     username: record?.username,
  //   };
  //   dispatch(fetchDeleteUser(payload))
  //     .then((res: any) => {
  //       // handleEditModal();
  //       getList();
  //     })
  //     .catch((error: any) => {
  //       console.log('error', error);
  //     });
  // };

  const handleDeleteRequest = (record: any) => {
    setOpenDeleteModal(!openDeleteModal);
    setOpenDeleteData(record);
  };

  const handleDeleteRequestClose = (record: any) => {
    setOpenDeleteModal(false);
    setOpenDeleteData({});
  };

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "index",
      key: "index",
      width: 80,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.index - b.index,
      render: (_, record) => {
        return record.index;
      },
    },
    {
      title: "Username",
      key: "username",
      dataIndex: "username",
      width: 120,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.username.localeCompare(b.username),
    },
    {
      title: "Full Name",
      key: "full_name",
      dataIndex: "full_name",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.full_name.localeCompare(b.full_name),
    },
    {
      title: "Email",
      key: "email",
      dataIndex: "email",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Role",
      key: "roles",
      dataIndex: "roles",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a?.[0].localeCompare(b?.[0]),
      render: (record) => {
        return record?.[0]
          ? camelCaseString(record?.[0])
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Status",
      key: "active",
      dataIndex: "active",
      width: 120,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => (a.active === b.active ? 0 : a.active ? 1 : -1),
      render: (_, record, index) => {
        return (
          <Switch
            value={record?.active === true ? true : false}
            disabled={record?.roles[0] === "admin" ? true : false}
            onChange={(e: boolean) => {
              handleBlockUser(record, e);
            }}
          />
        );
      },
    },
    // {
    //   title: 'language',
    //   key: 'language',
    //   dataIndex: 'language',
    //   width: 120,
    //   sortDirections: ['descend', 'ascend'],
    //   sorter: (a, b) => a.language.localeCompare(b.language),
    // },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 200,
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        a?.created_date?.toString().localeCompare(b?.created_date),
      render: (_, record) => {
        return record?.created_date
          ? record?.created_date
          : CONSTANT.NO_DATA_FOUND;
      },
    },
    {
      title: "Action",
      key: "action",
      width: 150,
      render: (_, record) => {
        return (
          <Space size="middle">
            <Tooltip title={"Edit User"}>
              <Button
                type="default"
                icon={<EditOutlined />}
                className="EditBtn iconBtn"
                onClick={() => {
                  handleEditModal(record);
                }}
              />
            </Tooltip>
            {/* <Popconfirm
              title="Delete the request"
              description="Are you sure to delete this request?"
              onConfirm={() => {
                handleDelete(record);
              }}
              // onCancel={false}
              okText="Delete"
              cancelText="Cancel"
            > */}
            <Tooltip title={"Delete User"}>
              <Button
                onClick={() => {
                  handleDeleteRequest(record);
                }}
                disabled={record?.roles[0] === "admin" ? true : false}
                icon={<DeleteOutlined />}
                type="default"
                className="cancelBtn iconBtn"
              />
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  const providersData: DataType[] = listData?.map((item, index) => ({
    key: index.toString(),
    index: item.index,
    username: item.username,
    full_name: item.full_name,
    email: item?.email,
    active: item.active,
    language: item.language,
    created_at: item.created_at,
    roles: item.roles,
    _id: item._id,
    created_date: item?.created_date,
  }));

  const handleChange: PaginationProps["onChange"] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    page_size
  ) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      current: current,
      page_size: page_size,
    };
    getList(updateData);
  };
  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={providersData}
          columns={columns}
          pagination={false}
          loading={tableloading}
        />
        <div className="text-center mt-20 mb-30">
          <Pagination
            defaultCurrent={1}
            current={paginationData?.current}
            total={totalData ?? 0}
            onChange={handleChange}
            responsive={true}
            pageSize={paginationData?.page_size}
            // showSizeChanger={totalData ? true : false}
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
          />
        </div>
      </div>

      <DeleteUser
        title={openDeleteData?.username}
        close={handleDeleteRequestClose}
        open={openDeleteModal}
        deleteValues={openDeleteData?.username}
        name={"Username"}
        getList={getList}
      />
    </>
  );
};
export default ListTable;
